/*
 * Copyright (c) Microsoft Corporation. All rights reserved. Licensed under the MIT License.
 */

import * as React from "react";
import { createRoot } from "react-dom/client";
import App from "./components/App";

/* global document, Office */

Office.onReady((info) => {
  if (info.host === Office.HostType.Excel) {
    // Hide the default HTML content
    const sideloadMsg = document.getElementById("sideload-msg");
    const appBody = document.getElementById("app-body");

    if (sideloadMsg) sideloadMsg.style.display = "none";
    if (appBody) appBody.style.display = "none";

    // Render the React app
    const container = document.getElementById("container");
    if (container) {
      const root = createRoot(container);
      root.render(React.createElement(App));
    }
  }
});

export async function run() {
  return Excel.run(async (context) => {
    /**
     * Insert your Excel code here
     */
    const range = context.workbook.getSelectedRange();

    // Read the range address
    range.load("address");

    // Update the fill color
    range.format.fill.color = "yellow";

    await context.sync();
    console.log(`The range address was ${range.address}.`);
  });
}
